import React, { useState } from 'react'
import {
  Autocomplete,
  Box,
  Button,
  ButtonGroup,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid2 as Grid,
  IconButton,
  InputAdornment,
  TablePagination,
  TextField,
  Typography,
  useTheme,
} from '@mui/material'
import useCustomStyles from '../../hooks/CustomStylesHook'
import ProposerCard from './ProposerCard'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import PeopleIcon from '@mui/icons-material/People'
import AccountCircleIcon from '@mui/icons-material/AccountCircle'
import SearchIcon from '@mui/icons-material/Search'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted'
import ViewModuleIcon from '@mui/icons-material/ViewModule'
import BookSlot from './BookSlot'
import Colors from '../../utils/colors.json'
import CloseIcon from '@mui/icons-material/Close'
import ArrowCircleUpIcon from '@mui/icons-material/ArrowCircleUp'
import StatusCard from '../../components/StatusCard'
import CallIcon from '@mui/icons-material/Call'
import { ReactComponent as ProgressIcon } from '../../assets/icons/Inprogress.svg'
import { ReactComponent as RejectedIcon } from '../../assets/icons/Rejected.svg'
import { ReactComponent as CompletedIcon } from '../../assets/icons/Completed.svg'
import { CARD_LAYOUT_OPTIONS, PAYMENT_OPTIONS } from '../../constants/constants'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import SmsOutlinedIcon from '@mui/icons-material/SmsOutlined'
import QrCode2OutlinedIcon from '@mui/icons-material/QrCode2Outlined'
import QRCode from 'react-qr-code'

const styles = (theme: any) => ({
  peopleContainer: {
    // border: '1px solid grey',
    // borderRadius: '20px 20px 20px 20px',
    flex: 1,
    overflowY: 'auto',
  },
  filterBtn: {
    color: theme.palette.primary.main,
    background: '#F1F1F1',
    borderRadius: 20,
    textTransform: 'capitalize',
  },
  searchField: {
    fontSize: '12px !important',
    borderRadius: 20,
    height: 30,
  },
  dialogActions: {
    justifyContent: 'center',
  },
  dialogCloseBtn: {
    position: 'absolute',
    right: 8,
    top: 8,
    color: theme.palette.grey[500],
  },
  assignedToDialog: {
    backgroundColor: Colors.MODAL_BG,
    display: 'flex',
    flexDirection: 'column',
  },
  assignedToSubmitBtn: {
    borderRadius: '18px',
    textTransform: 'capitalize',
    background: theme.customColors.btnGreen,
  },
  assignedToChangeBtn: {
    textTransform: 'capitalize',
    textDecoration: 'underline',
  },
  formTextField: {
    fontSize: '14px',
    fontWeight: 400,
    color: Colors.TEXT_COLOR_SECONDARY,
    height: 40,
    borderRadius: '20px',
  },
  assignedBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'row',
    border: '1px solid #D0D0D0',
    borderRadius: '20px',
    width: '70%',
    flexWrap: 'wrap',
    background: theme.customColors.button,
  },
  scrollContentContainer: {
    flex: 1,
    overflowY: 'auto',
    paddingRight: theme.spacing(2),
  },
  cardPagination: {
    '& .MuiTablePagination-toolbar': {
      minHeight: 0,
      padding: '0 16px',
    },
  },
  selectedLayoutBtn: {
    color: Colors.WHITE_BACKGROUND,
    background: theme.palette.primary.main,
  },

  paymentContainer: {
    display: 'flex',
    justifyContent: 'center',
    gap: '1rem',
    padding: '1rem',
    backgroundColor: '#f4f4f4',
    width: '100%',
  },
  pCard: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '1rem',
    minWidth: '140px',
    borderRadius: '8px',
    backgroundColor: '#eaeaea',
    '&:hover': {
      backgroundColor: '#d6d6d6',
    },
  },
  pCardActive: {
    backgroundColor: theme.palette.primary.main,
    color: '#fff',
    '&:hover': {
      backgroundColor: '#1e2847',
    },
  },
  paymentIcon: {
    marginBottom: '0.5rem',
  },
  paymentIconActive: {
    color: '#25D366',
  },
  paymentDialogActions: {
    justifyContent: 'center',
  },
  paymentBtn: {
    borderRadius: '18px',
    textTransform: 'capitalize',
    background: theme.customColors.button,
    marginBottom: 4,
  },
  primaryBtn: {
    borderRadius: '18px',
    textTransform: 'capitalize',
    background: theme.customColors.button,
  },
  secondaryBtn: {
    borderRadius: '18px',
    textTransform: 'capitalize',
    background: theme.customColors.btnBlack,
  },
})

const OperationsExecutive = () => {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)

  const filterCards = [
    {
      title: 'Pending Calls',
      icon: <CallIcon fontSize='small' />,
      count: 5,
      percentage: 2.5,
    },
    {
      title: 'In Progress',
      icon: <ProgressIcon />,
      count: 4,
      percentage: 2.5,
    },
    {
      title: 'Cancelled',
      icon: <RejectedIcon />,
      count: 28,
      percentage: 2.5,
    },
    {
      title: 'Completed',
      icon: <CompletedIcon />,
      count: 20,
      percentage: -2.5,
    },
  ]

  const [cardLayout, setCardLayout] = useState(CARD_LAYOUT_OPTIONS.LIST)
  const [openSlot, setOpenSlot] = useState(false)
  const [openAssignedTo, setOpenAssignedTo] = useState(false)
  const [selectedFilterCard, setSelectedFilterCard] = useState('Pending Calls')
  const [openPayment, setOpenPayment] = useState(false)
  const [selectedPaymentOption, setSelectedPaymentOption] = useState(
    PAYMENT_OPTIONS?.WHATSAPP
  )
  const [isGenerateQr, setIsGenerateQr] = useState(false)

  const buttons = [
    { name: 'WhatsApp', icon: WhatsAppIcon },
    { name: 'SMS', icon: SmsOutlinedIcon },
    { name: 'Generate QR', icon: QrCode2OutlinedIcon },
  ]

  // eslint-disable-next-line
  const [users, setUsers] = useState([
    { name: 'Vinod Gadde', id: 123453232 },
    { name: 'Aarav Sharma', id: 123453233 },
    { name: 'Isha Verma', id: 123453234 },
    { name: 'Rohit Mehta', id: 123453235 },
    { name: 'Sanya Kapoor', id: 123453236 },
    { name: 'Kabir Bansal', id: 123453237 },
    { name: 'Meera Nair', id: 123453238 },
    { name: 'Arjun Gupta', id: 123453239 },
    { name: 'Priya Singh', id: 123453240 },
    { name: 'Aditya Malhotra', id: 123453241 },
    { name: 'Riya Deshmukh', id: 123453242 },
  ])
  const [page, setPage] = React.useState(2)
  const [rowsPerPage, setRowsPerPage] = React.useState(10)

  const handlePaymentClick = () => {
    if (selectedPaymentOption === PAYMENT_OPTIONS?.GENERATEQR) {
      setIsGenerateQr(true)
    }
  }

  const handleOpenAssignedTo = () => {
    setOpenAssignedTo(true)
  }

  const handleCloseAssignedTo = () => {
    setOpenAssignedTo(false)
  }

  // const handleOpenPayment = () => {
  //   setOpenPayment(true)
  // }

  const handleClosePayment = () => {
    setSelectedPaymentOption(PAYMENT_OPTIONS?.WHATSAPP)
    setIsGenerateQr(false)
    setOpenPayment(false)
  }

  // const onBookSlot = () => {
  //   setOpenSlot(true)
  // }

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  return (
    <Grid
      container
      height={'100%'}
      width={'100%'}
      direction={'column'}
      spacing={2}
      // overflow={'hidden'}
    >
      <Dialog
        open={openPayment}
        onClose={handleClosePayment}
        fullWidth
        PaperProps={{
          className: classes?.assignedToDialog,
        }}
      >
        <DialogTitle m={0} p={2} id='customized-dialog-title' fontSize={'14px'}>
          Send Via
        </DialogTitle>
        <IconButton
          aria-label='close'
          onClick={handleClosePayment}
          className={classes?.dialogCloseBtn}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          {isGenerateQr ? (
            <Box display={'flex'} justifyContent={'center'}>
              <QRCode value='https://www.google.com' />
            </Box>
          ) : (
            <div className={classes?.paymentContainer}>
              {buttons?.map((button, index) => (
                <Card
                  key={index}
                  className={`${classes?.pCard} ${
                    button?.name === selectedPaymentOption
                      ? classes?.pCardActive
                      : ''
                  }`}
                  elevation={button?.name === selectedPaymentOption ? 4 : 1}
                  onClick={() => setSelectedPaymentOption(button?.name)}
                >
                  <IconButton className={classes?.paymentIcon}>
                    {
                      <button.icon
                        htmlColor={
                          button?.name === selectedPaymentOption
                            ? '#25D366'
                            : 'inherit'
                        }
                      />
                    }
                  </IconButton>
                  <Typography variant='body2'>{button?.name}</Typography>
                </Card>
              ))}
            </div>
          )}
        </DialogContent>
        <DialogActions className={classes?.paymentDialogActions}>
          <Button
            size='small'
            variant='contained'
            className={classes?.paymentBtn}
            onClick={handlePaymentClick}
          >
            {selectedPaymentOption === PAYMENT_OPTIONS?.GENERATEQR
              ? isGenerateQr
                ? 'Generate Again'
                : 'Generate'
              : 'Send Link'}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openAssignedTo}
        onClose={handleCloseAssignedTo}
        fullWidth
        PaperProps={{
          className: classes?.assignedToDialog,
        }}
      >
        <DialogTitle m={0} p={2} id='customized-dialog-title' fontSize={'14px'}>
          Select Operations Executive
        </DialogTitle>
        <IconButton
          aria-label='close'
          onClick={handleCloseAssignedTo}
          className={classes?.dialogCloseBtn}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <Box
            display={'flex'}
            justifyContent={'center'}
            alignItems={'center'}
            flexDirection={'column'}
            gap={3}
          >
            <Box
              display={'flex'}
              justifyContent={'space-between'}
              alignItems={'center'}
              flexDirection={'row'}
              border={'1px solid #D0D0D0'}
              borderRadius={'20px'}
              p={1}
              width={'70%'}
              flexWrap={'wrap'}
            >
              <Box
                display={'flex'}
                justifyContent={'start'}
                alignItems={'center'}
                flexDirection={'row'}
                gap={1}
              >
                <ArrowCircleUpIcon />
                <Box fontSize={'13px'}>5 Customers Selected</Box>
              </Box>
              <Button size='small' className={classes?.assignedToChangeBtn}>
                Change
              </Button>
            </Box>
            <Box className={classes?.assignedBox} p={1}>
              <Box
                display={'flex'}
                justifyContent={'start'}
                alignItems={'center'}
                flexDirection={'row'}
                gap={1}
              >
                <ArrowCircleUpIcon />
                <Box fontSize={'13px'}>Select Operator</Box>
              </Box>
              <Button
                size='small'
                variant='contained'
                className={classes?.assignedToSubmitBtn}
              >
                Submit
              </Button>
            </Box>
            <Box width={'70%'}>
              <Autocomplete
                multiple
                id='outlined'
                options={users}
                getOptionLabel={(option) => option?.name}
                filterSelectedOptions
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label='Operations Executives'
                    placeholder='Select Operations Executives'
                    size='small'
                  />
                )}
              />
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
      {openSlot && <BookSlot open={openSlot} setOpen={setOpenSlot} />}
      <Grid container direction={'row'} spacing={1.5}>
        {filterCards?.map((item, index) => (
          <Grid size={{ xs: 3 }} key={index}>
            <StatusCard
              icon={item?.icon}
              title={item?.title}
              count={item?.count}
              percentage={item?.percentage}
              selected={selectedFilterCard === item?.title ? true : false}
              onClick={() => setSelectedFilterCard(item?.title)}
            />
          </Grid>
        ))}
      </Grid>
      <Grid
        container
        spacing={5}
        direction={'row'}
        pr={2}
        position={'sticky'}
        top={0}
        zIndex={1}
        size={{ xs: 12 }}
      >
        <Grid size={{ xs: 12, sm: 12, lg: 6, md: 6, xl: 6 }}>
          <Box
            display={'flex'}
            flexDirection={'row'}
            justifyContent={'start'}
            flexWrap={'wrap'}
            rowGap={2}
            gap={4}
          >
            <Button
              variant='contained'
              className={classes?.filterBtn}
              endIcon={<KeyboardArrowDownIcon />}
              size='small'
            >
              Contacted - 9
            </Button>
            <Button
              variant='contained'
              className={classes?.primaryBtn}
              startIcon={<PeopleIcon />}
              size='small'
              onClick={handleOpenAssignedTo}
            >
              Assign to
            </Button>
            <Button
              variant='contained'
              className={classes?.secondaryBtn}
              endIcon={<AccountCircleIcon />}
              size='small'
            >
              Create Account
            </Button>
          </Box>
        </Grid>
        <Grid size={{ xs: 12, sm: 12, lg: 6, md: 6, xl: 6 }}>
          <Box
            display={'flex'}
            flexDirection={'row'}
            justifyContent={'end'}
            flexWrap={'wrap'}
            gap={4}
            rowGap={2}
          >
            <TextField
              placeholder='Search for Customers'
              type='search'
              size='small'
              slotProps={{
                input: {
                  className: classes?.searchField,
                  startAdornment: (
                    <InputAdornment position='start'>
                      <IconButton size='small'>
                        <SearchIcon fontSize='small' />
                      </IconButton>
                    </InputAdornment>
                  ),
                },
              }}
            />
            <Button
              variant='contained'
              className={classes?.filterBtn}
              startIcon={<FilterAltIcon />}
              size='small'
            >
              Filter
            </Button>
            <ButtonGroup>
              <Button
                variant='contained'
                className={`${classes?.filterBtn} ${
                  cardLayout === CARD_LAYOUT_OPTIONS.GRID
                    ? classes?.selectedLayoutBtn
                    : ''
                }`}
                size='small'
                onClick={() => setCardLayout(CARD_LAYOUT_OPTIONS.GRID)}
              >
                <ViewModuleIcon fontSize='small' />
              </Button>
              <Button
                variant='contained'
                className={`${classes?.filterBtn}  ${
                  cardLayout === CARD_LAYOUT_OPTIONS.LIST
                    ? classes?.selectedLayoutBtn
                    : ''
                }`}
                size='small'
                onClick={() => setCardLayout(CARD_LAYOUT_OPTIONS.LIST)}
              >
                <FormatListBulletedIcon fontSize='small' />
              </Button>
            </ButtonGroup>
          </Box>
        </Grid>
      </Grid>
      <Grid
        className={classes?.peopleContainer}
        size={{ xs: 12 }}
        pr={2}
        direction={'column'}
      >
        {cardLayout === CARD_LAYOUT_OPTIONS.LIST ? (
          <Grid container spacing={1.5} direction={'column'} size={{ xs: 12 }}>
            {Array.from({ length: 5 }).map((_, index) => (
              <ProposerCard
                key={index}
                onBookSlot={() => setOpenSlot(true)}
                onTriggerPayment={() => setOpenPayment(true)}
              />
            ))}
          </Grid>
        ) : null}
      </Grid>
      <Grid size={{ xs: 12 }}>
        <TablePagination
          className={classes?.cardPagination}
          component='div'
          count={100}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Grid>
    </Grid>
  )
}

export default OperationsExecutive
